import { CONTACT } from "./data";

// Sends the enquiry/contact form to our self-hosted PHP mailer at /mailer/sendmail.php.
// No third-party service, no API keys, see /public/mailer/README.md.
//
// During local development (yarn start on :3000) the PHP script is not served,
// so we short-circuit and resolve with a clear "dev-only" flag so the UI can
// show a helpful message instead of a hard error.
export async function submitEnquiry(payload) {
  const {
    name, email, phone, course, category, preferred_contact, message, source,
  } = payload;

  // Same-origin endpoint, resolves to https://your-domain.com/mailer/sendmail.php in production.
  const endpoint = "/mailer/sendmail.php";

  let res;
  try {
    res = await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        name, email,
        phone: phone || "",
        course: course || "",
        category: category || "",
        preferred_contact: preferred_contact || "",
        message,
        source: source || "",
        company: "", // honeypot, must stay empty
      }),
    });
  } catch (networkErr) {
    const err = new Error("network");
    err.code = "network";
    throw err;
  }

  // If PHP isn't available (e.g. local dev on the React dev server), the request
  // typically returns the HTML index.html with status 200, detect and flag it.
  const contentType = res.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) {
    const err = new Error("no-php");
    err.code = "no-php";
    err.hint = `Contact endpoint at ${endpoint} did not return JSON. On production (cPanel) this works automatically. Contact ${CONTACT.email} directly if this persists.`;
    throw err;
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.ok) {
    const err = new Error(data.error || `Request failed (${res.status})`);
    err.code = res.status === 429 ? "rate-limit" : "server";
    throw err;
  }
  return data;
}
